import { render } from "./Kefu.vue?vue&type=template&id=fb3d7ac0&scoped=true&ts=true"
import script from "./Kefu.vue?vue&type=script&lang=ts"
export * from "./Kefu.vue?vue&type=script&lang=ts"

import "./Kefu.vue?vue&type=style&index=0&id=fb3d7ac0&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3d7ac0"]])

export default __exports__